const schema = () => ({
  type: "object",
  required: [],
  properties: {
    // city_id: {
    //   type: "string",
    //   title: "شهر",
    // },
    title: {
      type: "string",
      title: "عنوان",
    },
    state_id: {
      type: "string",
      title: "استان",
    },
  },
});

export default schema;
